/**
 * Compatibility shim: wouter API → react-router-dom
 *
 * V5 pages were built with wouter. This shim lets them work inside
 * V1's react-router-dom without changing every V5 file.
 */
import {
  useLocation as useRRLocation,
  useNavigate,
  useParams as useRRParams,
} from "react-router-dom";

/**
 * wouter's useLocation returns [path, setLocation].
 * react-router's useLocation returns { pathname, search, ... }.
 */
export function useLocation(): [string, (to: string) => void] {
  const location = useRRLocation();
  const navigate = useNavigate();
  return [location.pathname, (to: string) => navigate(to)];
}

/**
 * wouter's useRoute returns [matched, params].
 * We approximate it using react-router's useParams.
 */
export function useRoute(
  _pattern?: string,
): [boolean, Record<string, string>] {
  const params = useRRParams();
  return [Object.keys(params).length > 0, params as Record<string, string>];
}

/**
 * wouter's useSearch returns the query string.
 */
export function useSearch(): string {
  const location = useRRLocation();
  return location.search;
}

export { useRRParams as useParams };
